<template>
    <div class="edurio-loading alert">
        <p>
            <img src="/material/img/edurio-loading.gif" alt height="36" />
            <span>Loading ...</span>
        </p>
    </div>
</template>

<script>
    export default {
        name: "Loading"
    }
</script>

<style scoped lang="scss">
    .edurio-loading.alert {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100px;
        background: $gray-1;
    }
</style>